<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12" md="12">
            <v-toolbar dense :color="this.$globalstore.secondary_titleclass">
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  Edit Proposal
               </v-toolbar-title>
               <v-toolbar-title v-else>
                  <v-icon color="white">mdi-playlist-edit</v-icon>
               </v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn color="indigo" class="white ma-2" outlined @click="updateProposal">
                  Save
               </v-btn>
               <v-btn color="indigo" class="white" outlined @click="goBack()">
                  Back
               </v-btn>
            </v-toolbar>
            <v-card elevation="2" class="pa-2">
               <v-row no-gutters>
                  <v-col cols="12" md="3">
                     <p :class="[leftgutter, 'mb-0']">Proposer: {{ proposer_name }}</p>
                  </v-col>
                  <v-col cols="12" md="3">
                     <p :class="[leftgutter, 'mb-0']">Role: {{ proposer_roletext }}</p>
                  </v-col>

                  <v-col cols="12" md="3">
                     <p :class="[leftgutter, 'mb-0']">Other Projects: {{ other_projects }}</p>
                  </v-col>
                  <v-col cols="12" md="3">
                     <p :class="[leftgutter, 'mb-0']">CCA Category: {{ cca_categorytext }}</p>
                  </v-col>
               </v-row>
               <v-row dense>
                  <v-col cols="12" md="12">
                     <span :class="[leftgutter, 'mb-0']">CCA Mastery:</span>
                     <span v-for="(mst, i) in cca_mastery" :key="i">
                        <v-chip
                           color="primary"
                           text-color="white"
                           class="ma-1"
                           close
                           label
                           small
                           @click:close="onMasteryClickClose(mst)"
                        >
                           {{ getMasteryText(mst) }}
                        </v-chip>
                     </span>
                  </v-col>
               </v-row>
            </v-card>
         </v-col>
         <v-col cols="12" md="12" class="pt-0">
            <v-row dense>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2">
                     <v-text-field
                        :class="[leftgutter, 'mt-3']"
                        dense
                        label="Group Name"
                        v-model="cca_name"
                        readonly
                     >
                     </v-text-field>
                     <v-text-field
                        :class="leftgutter"
                        dense
                        label="Revised Group Name"
                        v-model="rv_cca_name"
                        required
                        hide-details="auto"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2">
                     <v-text-field
                        :class="[leftgutter, 'mt-3']"
                        dense
                        label="Group Description"
                        v-model="cca_description"
                        readonly
                     >
                     </v-text-field>
                     <v-text-field
                        :class="leftgutter"
                        dense
                        label="Revised Group Description"
                        v-model="rv_cca_description"
                        required
                        hide-details="auto"
                        type="text"
                        :counter="DescriptionMaxLength"
                        :maxlength="DescriptionMaxLength"
                     >
                     </v-text-field>
                  </v-card>
               </v-col>
            </v-row>
            <v-row dense>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2">
                     <v-row no-gutters>
                        <v-col cols="6" md="6">
                           <label :class="[leftgutter, 'pb-0']"
                              >Preferred Day: {{ preferred_eventdaytext }}</label
                           >
                        </v-col>
                        <v-col cols="6" md="6">
                           <label>Duration: {{ event_duration }} minutes</label>
                        </v-col>
                     </v-row>
                     <v-text-field
                        :class="[leftgutter]"
                        v-model="location_requirement"
                        label="Location Requirement"
                        readonly
                     ></v-text-field>
                     <v-select
                        dense
                        :class="leftgutter"
                        v-model="rv_eventday"
                        label="Select Day"
                        :items="eventdayselect"
                        item-text="day"
                        item-value="dow"
                        return-object
                     >
                     </v-select>
                     <v-row no-gutters>
                        <v-col cols="12" md="6">
                           <label :class="leftgutter" for="start">Start Time</label>
                           <vue-timepicker
                              close-on-complete
                              class="ml-2 mb-2"
                              name="start"
                              :minute-interval="$globalstore.minute_interval"
                              v-model="rv_event_starttime"
                              drop-direction="down"
                              manual-input
                              auto-scroll
                           ></vue-timepicker>
                        </v-col>
                        <v-col cols="12" md="6">
                           <label :class="leftgutter" for="end">End Time</label>
                           <vue-timepicker
                              close-on-complete
                              class="ml-2"
                              name="end"
                              :minute-interval="$globalstore.minute_interval"
                              v-model="rv_event_endtime"
                              drop-direction="down"
                              manual-input
                              auto-scroll
                           ></vue-timepicker>
                        </v-col>
                     </v-row>
                     <v-row>
                        <v-col cols="12" md="12" class="py-1">
                           <v-autocomplete
                              dense
                              :class="[leftgutter, 'py-0']"
                              v-model="rv_location"
                              :items="locationdata"
                              label="Location"
                              item-text="location_name"
                              return-object
                           >
                              <template v-slot:item="data">
                                 <v-row dense>
                                    <v-col>
                                       <v-list-item-content>
                                          {{ data.item.location_name }}
                                       </v-list-item-content>
                                    </v-col>
                                    <v-col>
                                       <v-list-item-content>
                                          {{ data.item.location_description }}
                                       </v-list-item-content>
                                    </v-col>
                                 </v-row>
                              </template>
                           </v-autocomplete>
                        </v-col>
                     </v-row>
                  </v-card>
               </v-col>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2">
                     <v-row>
                        <v-col cols="6" md="6">
                           <v-text-field
                              dense
                              :class="leftgutter"
                              v-model="max_participant"
                              label="Maximum Participant"
                              readonly
                              hide-details="auto"
                           ></v-text-field>
                        </v-col>
                        <v-col cols="6" md="6">
                           <v-text-field
                              dense
                              v-model="rv_max_participant"
                              label="Revised Maximum Participant"
                              :rules="rules_max_participant"
                              hide-details="auto"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-card>
                  <v-card elevation="2" class="pa-2 mt-2">
                     <v-row>
                        <v-checkbox
                           v-for="yr in yeargroup"
                           :key="yr"
                           v-model="cca_yeargroup"
                           dense
                           :class="[leftgutter, 'mr-2', 'pa-0']"
                           :label="'Year ' + yr"
                           :value="yr"
                           @change="yearChange(yr)"
                        ></v-checkbox>
                     </v-row>
                  </v-card>
                  <v-card elevation="2" class="px-2 pt-2 pb-9 mt-2">
                     <v-row>
                        <v-col cols="2" md="2">
                           <label :class="leftgutter">Fee Req:</label>
                           <p :class="leftgutter">{{ cca_fee_required }}</p>
                        </v-col>
                        <v-col cols="7" md="7" align-self="end">
                           <v-text-field
                              label="Fee Description"
                              v-model="cca_fee_description"
                              hide-details="auto"
                           >
                           </v-text-field>
                        </v-col>
                        <v-col cols="3" md="3" align-self="end">
                           <v-text-field
                              dense
                              label="CCA Fee"
                              v-model="rv_cca_fee"
                              :rules="rules_cca_fee"
                              hide-details="auto"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-card>
               </v-col>
            </v-row>
            <v-row dense>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2 mt-2">
                     <v-row dense>
                        <v-col cols="12" md="12" align-self="start">
                           <v-text-field
                              :class="leftgutter"
                              dense
                              v-model="materialtool_usage"
                              label="Material &amp; Tools Used"
                              hide-details="auto"
                           ></v-text-field>
                        </v-col>
                        <v-col cols="3" md="3">
                           <label :class="[leftgutter, 'py-0']">Bring Own Material: </label>
                           <p :class="[leftgutter, 'py-0']">
                              {{ own_material }}
                           </p>
                        </v-col>
                        <v-col cols="9" md="9" align-self="end">
                           <v-text-field
                              :class="leftgutter"
                              dense
                              v-model="material_requirement"
                              label="Material Required"
                           ></v-text-field>
                        </v-col>
                     </v-row>
                  </v-card>
               </v-col>
               <v-col cols="12" md="6">
                  <v-card elevation="2" class="pa-2 mt-2">
                     <v-data-table
                        dense
                        :headers="admin_header"
                        :items="admindata"
                        item-key="id"
                        single-select
                        hide-default-footer
                        @click:row="adminRowClick"
                     >
                        <!-- eslint-disable-next-line -->
                        <template v-slot:item.actions="{item}">
                           <v-icon class="ml-2" small @click="rejectAssistingTeacher(item)"
                              >mdi-delete
                           </v-icon>
                        </template>
                     </v-data-table>
                  </v-card>
               </v-col>
            </v-row>
            <v-row dense justify="center">
               <v-col cols="12" md="12" align-self="center">
                  <v-card elevation="2" class="pa-2 mt-2">
                     <v-row justify="center">
                        <v-col cols="6" md="4">
                           <v-select
                              label="Status"
                              :disabled="proposalStatusCheck"
                              v-model="proposalstatus"
                              :items="proposalstatus_select"
                              item-text="text"
                              item-value="id"
                              return-object
                           ></v-select>
                        </v-col>
                        <v-col cols="6" md="4" align-self="center">
                           <v-btn
                              :disabled="disableCreateBtnCheck"
                              color="primary white--text"
                              block
                              @click="createGroup"
                              >Create Group</v-btn
                           >
                        </v-col>
                        <v-col cols="12" md="4" align-self="center">
                           <span v-if="linked_ccaid"
                              >Group created on {{ proposal_modifydate }}
                           </span>
                        </v-col>
                     </v-row>
                  </v-card>
               </v-col>
            </v-row>
         </v-col>

         <!-- create group dialog -->
         <v-dialog
            v-model="creategrpdialog"
            persistent
            width="500px"
            height="350px"
            @keydown.esc="dlgCancelBtnClick"
         >
            <v-sheet height="33vh">
               <v-row no-gutters>
                  <v-col cols="12">
                     <v-toolbar flat dense :class="$globalstore.toolbar_headerclass">
                        <v-toolbar-title>
                           Create Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn @click.native="dlgCancelBtnClick" class="mx-2">Cancel </v-btn>
                        <v-btn @click.native="dlgOkBtnClick" class="mx-2">OK </v-btn>
                     </v-toolbar>
                  </v-col>
               </v-row>

               <v-row no-gutters>
                  <v-col cols="12" md="10">
                     <v-card flat class="pt-5 px-3">
                        <v-select
                           dense
                           class="px-3"
                           label="Gender"
                           :items="$globalstore.gender_select"
                           item-text="text"
                           item-value="id"
                           return-object
                           v-model="selectedgender"
                           :rules="[(v) => !!v || 'Gender is required']"
                        >
                        </v-select>
                        <v-select
                           dense
                           class="px-3"
                           label="CCA Schedule"
                           :items="scheduledata"
                           item-text="schedule_name"
                           item-value="id"
                           return-object
                           v-model="selectedschedule"
                           full-width
                        >
                           <template v-slot:item="data">
                              <v-row dense>
                                 <v-col>
                                    <v-list-item-content>
                                       {{ data.item.schedule_name }}
                                    </v-list-item-content>
                                 </v-col>
                                 <v-col>
                                    <v-list-item-content>
                                       {{ data.item.termyeartext }}
                                    </v-list-item-content>
                                 </v-col>
                              </v-row>
                           </template>
                        </v-select>
                     </v-card>
                  </v-col>
               </v-row>
               <v-row no-gutters>
                  <v-col cols="12" md="12">
                     <v-card flat class="px-3">
                        <v-row no-gutters>
                           <v-col cols="6" md="5" class="px-2">
                              <datepicker-dialog
                                 labelname="Publish Date"
                                 :indate.sync="publishdate"
                                 @return-date="onPublishDateChange"
                              >
                              </datepicker-dialog>
                           </v-col>
                           <v-col cols="6" md="5" class="px-2">
                              <datepicker-dialog
                                 labelname="Close Date"
                                 :indate.sync="closingdate"
                                 @return-date="onClosingDateChange"
                              >
                              </datepicker-dialog>
                           </v-col>
                        </v-row>
                     </v-card>
                  </v-col>
               </v-row>
            </v-sheet>
         </v-dialog>

         <confirm-dlg ref="confirm"></confirm-dlg>
         <show-toast ref="toast"></show-toast>
      </v-row>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import {GroupConst, DESCRIPTION_MAXLENGTH} from "@/common/constant.js";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import ShowToast from "@/components/showToast.vue";
   import DatepickerDialog from "@/components/DatepickerDialog.vue";

   export default {
      components: {ConfirmDlg, VueTimepicker, ShowToast, DatepickerDialog},

      inject: ["ShowMessage"],

      data() {
         return {
            DescriptionMaxLength: DESCRIPTION_MAXLENGTH,
            CCA_ROLE: {
               LEAD_TEACHER: 1,
               ASSISTING_TEACHER: 2,
            },
            PROPOSAL_STATUS: {
               PENDING: 0,
               APPROVED: 1,
               REJECTED: 2,
               KIV: 3,
            },
            CCA_MASTERY: [
               {id: 1, text: "Leadership"},
               {id: 2, text: "Moral"},
               {id: 3, text: "Emotional"},
               {id: 4, text: "Intellectual"},
               {id: 5, text: "Career"},
               {id: 6, text: "Physical"},
               {id: 7, text: "Creative"},
               {id: 8, text: "Social"},
               {id: 9, text: "Technology"},
            ],
            CCA_CATEGORY: [
               {id: 1, text: "Academic/Intellectual"},
               {id: 2, text: "Creative Arts"},
               {id: 3, text: "Language/Cultural"},
               {id: 4, text: "Music/Performing Arts"},
               {id: 5, text: "Sports/Physical"},
               {id: 6, text: "Technology"},
            ],
            admin_header: [
               {
                  text: "Assisting Teachers",
                  value: "proposer_name",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  align: "end",
                  class: this.$globalstore.table_headerclass,
               },
            ],

            adminstatus_text: [
               {id: 0, text: "Pending"},
               {id: 1, text: "Approved"},
               {id: 2, text: "Rejected"},
               {id: 3, text: "KIV"},
            ],

            yeargroup: GroupConst.yearselect,
            eventdayselect: GroupConst.eventdayselect,
            leftgutter: "pl-2",
            proposal_id: "",
            cca_year: "",
            cca_term: "",
            proposer_id: "",
            proposer_name: "",
            other_projects: "",
            proposer_role: "",
            proposer_roletext: "",
            cca_category: "",
            cca_name: "",
            cca_description: "",
            preferred_eventday: "",
            preferred_eventdaytext: "",
            event_duration: 0,
            location_requirement: "",
            locationdata: [],
            max_participant: "",
            cca_mastery: [],
            cca_yeargroup: [],
            cca_fee_required: "",
            cca_fee_description: "",
            material_requirement: "",
            own_material: "",
            materialtool_usage: "",
            admindata: [],
            rv_cca_name: "",
            rv_cca_description: "",
            rv_location: null,
            rv_max_participant: "",
            rv_event_starttime: "",
            rv_event_endtime: "",
            rv_eventday: "",
            rv_cca_fee: "0.00",
            proposalstatus: null,
            proposalstatus_select: [
               {id: 0, text: "Pending"},
               {id: 1, text: "Approved"},
               {id: 2, text: "Rejected"},
               {id: 3, text: "KIV"},
            ],
            selectedgender: null,
            rules_max_participant: [
               (v) => !!/^[0-9]+$/.test(v) || "Max participants must be numeric.",
            ],
            rules_cca_fee: [
               (v) => !!/^\d+(\.\d{2})$/.test(v) || "CCA fee must have 2 numeric decimal places.",
            ],
            linked_ccaid: "",
            proposal_modifydate: "",
            creategrpdialog: false,
            scheduledata: [],
            selectedschedule: null,
            publishdate: "",
            closingdate: "",
            terminfo: null,
         };
      },

      computed: {
         cca_categorytext() {
            if (this.cca_category) {
               let index = this.CCA_CATEGORY.findIndex((x) => x.id == this.cca_category);
               if (index !== -1) return this.CCA_CATEGORY[index].text;
            } else {
               return "";
            }
         },

         disableCreateBtnCheck() {
            if (this.linked_ccaid) return true;

            if (this.proposalstatus && this.proposalstatus.id !== this.PROPOSAL_STATUS.APPROVED)
               return true;

            return false;
         },

         proposalStatusCheck() {
            return this.linked_ccaid ? true : false;
         },
      },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         adminRowClick(item, row) {
            row.select(!row.isSelected);
         },

         getMasteryText(mstid) {
            let index = this.CCA_MASTERY.findIndex((x) => x.id == mstid);
            return index !== -1 ? this.CCA_MASTERY[index].text : "";
         },

         onMasteryClickClose(mst) {
            this.removeMastery(mst);
         },

         yearChange(yr) {
            if (this.cca_yeargroup.indexOf(yr) !== -1) {
               this.doAddYear(yr);
            } else {
               this.doRemoveYear(yr);
            }
         },

         async doAddYear(year) {
            let response = await this.$http({
               url: "/cca/addproposalyear.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  year: year,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: "Year added.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async doRemoveYear(year) {
            let response = await this.$http({
               url: "/cca/removeproposalyear.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  year: year,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: "Year removed.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async removeMastery(mst) {
            let response = await this.$http({
               url: "/cca/removemastery.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  mst: mst,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     var mastery = this.cca_mastery;
                     this.cca_mastery = mastery.filter((x) => {
                        return !(x == mst);
                     });
                     this.$refs.toast.display({
                        message: "Mastery removed successfully",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         rejectAssistingTeacher(item) {
            this.$refs.confirm
               .open(
                  "Warning",
                  "Removing assisting teacher " +
                     item.proposer_name +
                     " will reject his/her proposal. Are you sure you want to reject this teacher's proposal?",
                  {color: "orange"}
               )
               .then((reply) => {
                  if (reply) {
                     this.doRejectAssistingTeacher(item);
                  }
               });
         },

         async doRejectAssistingTeacher(item) {
            let response = await this.$http({
               url: "/cca/removeassistingteacher.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  asst_proposal_id: item.asst_proposal_id,
                  main_proposal_id: this.proposal_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadAssistingTeacher();
                  }
               }
            });
         },

         async reloadAssistingTeacher() {
            let response = await this.$http({
               url: "/cca/getproposalassistingteacher.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.admindata = response.data.administrator;
                  }
               }
            });
         },

         async loadProposal() {
            let response = await this.$http({
               url: "/cca/getproposalbyid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let proposal = response.data.proposaldata;
                     console.log(proposal);
                     this.proposer_id = proposal.proposer_id;
                     this.proposer_name = proposal.proposer_name;
                     this.cca_year = proposal.cca_year;
                     this.cca_term = proposal.cca_term;
                     this.proposer_role = proposal.proposer_role;
                     this.proposer_roletext =
                        this.proposer_role == this.CCA_ROLE.LEAD_TEACHER
                           ? "Lead Teacher"
                           : "Assisting Teacher";
                     this.other_projects = proposal.other_projects;
                     this.cca_name = proposal.cca_name;
                     this.rv_cca_name = proposal.rv_cca_name ? proposal.rv_cca_name : this.cca_name;
                     this.cca_description = proposal.cca_description;
                     this.rv_cca_description = proposal.rv_cca_description
                        ? proposal.rv_cca_description
                        : this.cca_description;
                     this.location_requirement = proposal.location_requirement;
                     this.rv_location = this.locationdata.find(
                        (x) => x.location_id == proposal.rv_location_id
                     );
                     this.max_participant = proposal.max_participant;
                     this.rv_max_participant = proposal.rv_max_participant
                        ? proposal.rv_max_participant
                        : this.max_participant;
                     this.event_duration = proposal.cca_timeslot;
                     this.rv_event_starttime = proposal.rv_event_starttime
                        ? proposal.rv_event_starttime
                        : "15:30";
                     this.rv_event_endtime = proposal.rv_event_endtime
                        ? proposal.rv_event_endtime
                        : this.event_duration == "50"
                        ? "16:20"
                        : "17:00";
                     this.preferred_eventday = proposal.preferred_eventday;
                     this.preferred_eventdaytext = proposal.preferred_eventdaytext;

                     this.rv_eventday = proposal.rv_eventday
                        ? this.eventdayselect.find((x) => x.dow == proposal.rv_eventday)
                        : this.eventdayselect.find((x) => x.dow == this.preferred_eventday);
                     this.cca_category = proposal.cca_category;
                     this.cca_mastery = proposal.cca_mastery;
                     this.cca_yeargroup = proposal.cca_yeargroup.map((x) => x.toString());

                     this.admindata = proposal.administrator;
                     this.materialtool_usage = proposal.materialtool_usage;
                     this.material_requirement = proposal.material_requirement;
                     this.own_material = proposal.own_material == 0 ? "No" : "Yes";
                     this.cca_fee_required = proposal.cca_fee_required == 0 ? "No" : "Yes";
                     this.cca_fee_description = proposal.cca_fee_description;
                     this.rv_cca_fee = proposal.rv_cca_fee ? proposal.rv_cca_fee : "0.00";
                     this.proposalstatus = this.proposalstatus_select.find(
                        (x) => x.id == proposal.admin_status
                     );
                     this.linked_ccaid = proposal.linked_ccaid;
                     this.proposal_modifydate = proposal.modifydate;
                  }
               }
            });
         },

         async updateProposal() {
            let response = await this.$http({
               url: "/cca/admin_updateproposal.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposer_id: this.proposer_id,
                  proposer_name: this.proposer_name,
                  proposal_id: this.proposal_id,
                  cca_name: this.rv_cca_name,
                  cca_description: this.rv_cca_description,
                  eventday: this.rv_eventday.dow,
                  event_starttime: this.rv_event_starttime,
                  event_endtime: this.rv_event_endtime,
                  location_id: this.rv_location ? this.rv_location.location_id : -1,
                  admin_status: this.proposalstatus.id,
                  max_participant: this.rv_max_participant,
                  cca_fee: this.rv_cca_fee,
                  admindata: this.admindata,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     let index = this.$globalstore.proposal.proposaldata.findIndex(
                        (x) => x.id === this.proposal_id
                     );
                     if (index !== -1) {
                        var adminstatustext;
                        this.$set(
                           this.$globalstore.proposal.proposaldata[index],
                           "admin_status",
                           this.proposalstatus.id
                        );
                        adminstatustext = this.adminstatus_text.find(
                           (x) => x.id === this.proposalstatus.id
                        ).text;
                        if (adminstatustext) {
                           this.$set(
                              this.$globalstore.proposal.proposaldata[index],
                              "adminstatustext",
                              adminstatustext
                           );
                        }
                     }
                     this.$refs.toast.display({
                        message: "Proposal updated successfully.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         checkProposalValues() {
            if (!this.rv_cca_name) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA name is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_cca_description) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA description is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_eventday) {
               this.ShowMessage({
                  title: "Error",
                  message: "Event day is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_event_starttime) {
               this.ShowMessage({
                  title: "Error",
                  message: "Event start time is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_event_endtime) {
               this.ShowMessage({
                  title: "Error",
                  message: "Event end time is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_location) {
               this.ShowMessage({
                  title: "Error",
                  message: "Location is required.",
                  color: "red",
               });
               return false;
            }

            if (!this.rv_max_participant) {
               this.ShowMessage({
                  title: "Error",
                  message: "Maximum participant is required.",
                  color: "red",
               });
               return false;
            }

            if (this.cca_yeargroup.length === 0) {
               this.ShowMessage({
                  title: "Error",
                  message: "There must be at least one year group selected.",
                  color: "red",
               });
               return false;
            }

            // Proposal rejected
            if (this.proposalstatus.id == this.PROPOSAL_STATUS.REJECTED) {
               this.ShowMessage({
                  title: "Error",
                  message: "Proposal status is rejected. Group cannot be created.",
                  color: "red",
               });
               return false;
            }

            return true;
         },

         getDefaultPublishClosingDates() {
            if (this.$globalstore.proposal.publishdate) {
               this.publishdate = this.$globalstore.proposal.publishdate;
            } else {
               this.publishdate = this.terminfo.term_start;
            }

            if (this.$globalstore.proposal.closingdate) {
               this.closingdate = this.$globalstore.proposal.closingdate;
            } else {
               let d1 = new Date(this.publishdate);
               d1.setDate(d1.getDate() + 7);
               //this.closingdate = d1.toISOString().substr(0, 10);
               this.closingdate = this.$globalstore.dateToISOString(d1).substr(0, 10);
            }
         },

         async createGroup() {
            if (this.checkProposalValues()) {
               // Set default values
               // Set to co-ed
               this.selectedgender = this.$globalstore.gender_select.find((x) => x.id == 2);
               await this.LoadTermInfo();
               await this.LoadScheduleList();
               this.getDefaultPublishClosingDates();
               this.creategrpdialog = true;
            }
         },

         dlgCancelBtnClick() {
            this.creategrpdialog = false;
         },

         dlgOkBtnClick() {
            if (this.publishdate > this.closingdate) {
               this.ShowMessage({
                  title: "Error",
                  message: "Closing date must be greater than publish date.",
                  color: "red",
               });
               return;
            }

            if (!this.selectedschedule) {
               this.ShowMessage({
                  title: "Error",
                  message: "CCA schedule is required.",
                  color: "red",
               });
               return;
            }

            this.creategrpdialog = false;
            this.doCreateGroup();
         },

         onPublishDateChange(date) {
            this.publishdate = date;
            this.$globalstore.proposal.publishdate = this.publishdate;
         },

         onClosingDateChange(date) {
            this.closingdate = date;
            this.$globalstore.proposal.closingdate = this.closingdate;
         },

         async doCreateGroup() {
            var groupadmin;

            if (this.admindata) {
               var groupadmin = this.admindata.slice();
               groupadmin.push({
                  id: this.proposer_id,
                  name: this.proposer_name,
               });
            } else {
               groupadmin = [];
            }
            let response = await this.$http({
               url: "/cca/save_ccagroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  schedule_id: this.selectedschedule.id,
                  cca_name: this.rv_cca_name,
                  cca_description: this.rv_cca_description,
                  cca_status: 1, // enable the group by default
                  cca_year: this.cca_year,
                  cca_term: this.cca_term,
                  gender_constraint: this.selectedgender.id,

                  year_constraint:
                     this.cca_yeargroup.length > 0 ? this.cca_yeargroup.map(Number) : 0,
                  min_participant: 1, // default
                  max_participant: this.rv_max_participant,
                  consent_required: false, // default
                  limit_participant: 0,
                  publish_date: this.publishdate,
                  publish_time: this.$globalstore.appsettings.cca_publish_time,
                  closing_date: this.closingdate,
                  closing_time: this.$globalstore.appsettings.cca_closing_time,
                  cca_fee: this.rv_cca_fee,
                  event_daytime: [
                     {
                        dow: this.rv_eventday.dow,
                        start: this.rv_event_starttime,
                        end: this.rv_event_endtime,
                        location_id: this.rv_location.location_id,
                     },
                  ],
                  event_admin: groupadmin,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.linked_ccaid = response.data.groupid;
                     this.doUpdateProposalLink(response.data.groupid);
                  }
               }
            });
         },

         async doUpdateProposalLink(groupid) {
            let response = await this.$http({
               url: "/cca/updateproposallink.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  proposal_id: this.proposal_id,
                  linked_ccaid: groupid,
                  admindata: this.admindata,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: "CCA group created successfully.",
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async LoadScheduleList() {
            let response = await this.$http({
               url: "/cca/getschedulelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.cca_year,
                  cca_term: this.cca_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.scheduledata = response.data.scheduledata;
                  }
               }
            });
         },

         async LoadLocationList() {
            await this.$http({
               url: "/cca/locationlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.ShowMessage({
                     title: "Error",
                     message: response.data.message,
                     color: "red",
                  });
               } else {
                  this.locationdata = response.data.locationlist;
               }
            });
         },

         async LoadTermInfo() {
            let response = await this.$http({
               url: "/common/getterminfo.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.cca_year,
                  cca_term: this.cca_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.terminfo = response.data.terminfo;
                  }
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$route.params.proposalid) {
               this.proposal_id = this.$route.params.proposalid;
               this.LoadLocationList();
               this.loadProposal();
            }
         }
      },
   };
</script>
